module.exports = __webpack_public_path__ + "img/coc-sign.69439074.jpg";